import moment from "moment";

export const formatMoment = (time: string) => {
    const isUTC = localStorage.getItem("isUTC") === "true"; // Retrieve from localStorage
    return isUTC
        ? moment(time).utc().format("MM/DD/YYYY HH:mm:ss[z]")
        : moment(time).format("MM/DD/YYYY HH:mm");
};